/*
 * Used throughout animation interpolation to normalize array-like values
 */

export class ArrayLikeUtils {
  // Convert value to array, or [] if not array-like.
  // Handles plain arrays [1, 2, 3], TypedArrays Int32Array([1, 2, 3])
  static toArray<T = number>(value: unknown): T[] {
    if (value == null) {
      return [] as T[];
    }

    if (ArrayBuffer.isView(value)) {
      // Convert TypedArray to array using type-safe iteration
      const result: T[] = [];
      const typedArray = value as unknown as { length: number; [index: number]: T };
      for (let i = 0; i < typedArray.length; i++) {
        result.push(typedArray[i]);
      }
      return result;
    }

    if (Array.isArray(value)) {
      return value as T[];
    }

    return [] as T[];
  }

  // Convert array back to original type format. Preserves TypedArrays.
  static preserveType<T extends ArrayBufferView>(original: T, values: number[]): T {
    if (ArrayBuffer.isView(original)) {
      // Create new TypedArray of same type using constructor
      const constructor = original.constructor as new (values: number[]) => T;
      return new constructor(values);
    }
    return values as unknown as T;
  }
}
